<template>
  <div class="max-1k mdl-grid charts" id="charts-container">
    <div class="mdl-card mdl-cell mdl-cell--12-col mdl-shadow--2dp by-day-chart" v-if="by_day">
      <div class="mdl-card__title mdl-color--primary mdl-color-text--white">
        <h4>By day</h4>
      </div>
      <div class="mdl-card__supporting-text">
        <area-chart id=by_day
           :data=by_day
           xkey=date
           :ykeys=ykeys
           :line-colors=area_colors
           grid=true
           resize=true
         ></area-chart>
      </div>
    </div>
    <div class="mdl-card mdl-cell mdl-cell--4-col mdl-shadow--2dp by-org-chart" v-if="by_org">
      <div class="mdl-card__title mdl-color--primary mdl-color-text--white">
        <h4>By organization</h4>
      </div>
      <div class="mdl-card__supporting-text">
        <donut-chart id=by_org :data=by_org :colors=pie_colors resize="true"></donut-chart>
      </div>
    </div>
    <div class="mdl-card mdl-cell mdl-cell--4-col mdl-shadow--2dp by-email-chart" v-if="by_email">
      <div class="mdl-card__title mdl-color--primary mdl-color-text--white">
        <h4>By email</h4>
      </div>
      <div class="mdl-card__supporting-text">
        <donut-chart id=by_email :data=by_email :colors=pie_colors resize="true"></donut-chart>
      </div>
    </div>
    <div class="mdl-card mdl-cell mdl-cell--4-col mdl-shadow--2dp by-browser-chart" v-if="by_browser">
      <div class="mdl-card__title mdl-color--primary mdl-color-text--white">
        <h4>By browser</h4>
      </div>
      <div class="mdl-card__supporting-text">
        <donut-chart id=by_browser :data=by_browser :colors=pie_colors resize="true"></donut-chart>
      </div>
    </div>
  </div>
</template>

<script>
import URI from "urijs"
import Raphael from 'raphael/raphael'
import { DonutChart, AreaChart } from "vue-morris"

global.Raphael = Raphael

const pie_colors = [
  "#36A2EB",
  '#0BA462',
  '#95D7BB',
  "#FF6384",
  '#39B580',
  '#67C69D',
  "#FFCE56"
]

function extract_pie(data) {
  var ret = []
  for(var idx in data) {
    var el = data[idx]
    ret.push({
      label: el.key,
      value: el.doc_count
    })
  }
  return ret
}

function extract_time(data) {
  var ret = []
  for(var idx in data) {
    var el = data[idx]
    ret.push({
      date:  el.key_as_string.slice(0, 10),
      value: el.doc_count
    })
  }
  return ret
}

export default {
  data() {
    return {
      by_email:    null,
      by_org:      null,
      by_browser:  null,
      by_day:      null,
      pie_colors:  pie_colors,
      area_colors: ["#009688"],
      ykeys:       ["value"]
    }
  },
  mounted() {
    var uri = URI(document.location.toString())
    $.get(uri, data => {
      this.by_email   = extract_pie(data.by_email)
      this.by_org     = extract_pie(data.by_org)
      this.by_browser = extract_pie(data.by_browser)
      this.by_day     = extract_time(data.by_day)
    }, "json")
  },
  components: {
    DonutChart, AreaChart
  }
}
</script>
<style scoped>
h4 { width: 100%; text-align: center }
.mdl-card__supporting-text { margin: 0 auto }
</style>



// WEBPACK FOOTER //
// chart_view.vue?46da1877